import { Injectable } from '@angular/core'
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap'

@Injectable()
export class TooltipConfig extends NgbTooltipConfig {
    tooltipClass = 'custom-tooltip'
    placement = 'top top-right top-left'
    container = 'body'
}
